import { api } from './api';

export interface EigeneAufgabeItem {
  id: string;
  label: string;
  done: boolean;
}

export interface EigeneAufgabe {
  id: number;
  titel: string;
  customerId: number | null;
  kundeName: string | null;
  vorgangId: number | null;
  vorgangsnummer: string | null;
  frist: string | null;
  notiz: string | null;
  items: EigeneAufgabeItem[];
  status: 'offen' | 'erledigt';
  zustaendigUserId: number | null;
  zustaendigName: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface NeueAufgabe {
  titel: string;
  customerId?: number | null;
  kundeFreitext?: string | null;
  vorgangId?: number | null;
  vorgangFreitext?: string | null;
  frist?: string | null;
  notiz?: string | null;
  zustaendigUserId?: number | null;
  items?: Array<{ label: string }>;
}

export const listEigeneAufgaben = () => api.get<EigeneAufgabe[]>('/api/eigene-aufgaben');

export const createEigeneAufgabe = (input: NeueAufgabe) =>
  api.post<EigeneAufgabe>('/api/eigene-aufgaben', input);

export const patchEigeneAufgabe = (
  id: number,
  patch: { titel?: string; frist?: string | null; notiz?: string | null; zustaendigUserId?: number | null },
) => api.patch<EigeneAufgabe>(`/api/eigene-aufgaben/${id}`, patch);

export const toggleEigenesItem = (id: number, itemId: string, done: boolean) =>
  api.patch<EigeneAufgabe>(`/api/eigene-aufgaben/${id}/items/${itemId}`, { done });

export const addEigenesItem = (id: number, label: string) =>
  api.post<EigeneAufgabe>(`/api/eigene-aufgaben/${id}/items`, { label });

export const removeEigenesItem = (id: number, itemId: string) =>
  api.delete<EigeneAufgabe>(`/api/eigene-aufgaben/${id}/items/${itemId}`);

export const setEigeneAufgabeStatus = (id: number, status: 'offen' | 'erledigt') =>
  api.patch<{ ok: true }>(`/api/eigene-aufgaben/${id}/status`, { status });

export const deleteEigeneAufgabe = (id: number) =>
  api.delete<{ ok: true }>(`/api/eigene-aufgaben/${id}`);

/**
 * Reihenfolge: Frist zuerst (früheste oben), Aufgaben ohne Frist danach.
 *
 * Dieselbe Logik wie bei den Nachforderungen — wer eine Frist gesetzt hat, meinte sie auch.
 * Ohne Frist entscheidet das Anlagedatum, neueste zuerst.
 */
export function sortEigeneAufgaben<T extends { frist: string | null; createdAt: string }>(list: T[]): T[] {
  return [...list].sort((a, b) => {
    if (a.frist && b.frist) return new Date(a.frist).getTime() - new Date(b.frist).getTime();
    if (a.frist) return -1;
    if (b.frist) return 1;
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
  });
}
